// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"59":"757d28a5f443b457","490":"1f722ecd94468cfd","537":"f1c232cc8280b9c7"}[chunkId] + ".js";
};